/* eslint-disable max-len */
// Bootstrap components
import 'bootstrap-sass/assets/javascripts/bootstrap/carousel';
import 'bootstrap-sass/assets/javascripts/bootstrap/transition';
import Component from '../site/Component';

const Hammer = require('hammerjs');

/**
 * Component for carousels
 */
export default class Carousel extends Component {
  /**
   * Start the component (called when Component is instantiated)
   */
  start() {
    /**
     * The HBG-2023 theme uses a different carousel component, which clashes
     * with this class due to sharing the root selector.
     */
    if (null !== this.element.querySelector('ai-carousel')) {
      return;
    }

    // Elements
    this.prev = this.element.querySelector(this.elements.prev);
    this.next = this.element.querySelector(this.elements.next);
    this.indicatorWrapper = this.element.querySelector(this.elements.indicatorWrapper);
    this.indicators = this.element.querySelectorAll(this.elements.indicator);
    this.slides = this.element.querySelectorAll(this.elements.slide);
    this.slidesWrapper = this.element.querySelector(this.elements.slidesWrapper);
    this.currentSlideItems = this.element.querySelectorAll(this.elements.slideItem);
    this.numDesktopSlideItems = this.element.dataset.desktopSlideItems;
    this.numDesktopRows = this.element.dataset.desktopSlideRows;
    this.numMobileSlideItems = this.element.dataset.mobileSlideItems;
    this.carouselBreakpoint = this.utils.breakpoints.generateMedia('m', false);
    this.touchHandler = new Hammer(this.element);
    this.makeSlides = this.makeSlides.bind(this);
    this.addMinHeight = this.addMinHeight.bind(this);
    this.tabId = this.element.parentElement.dataset.title;

    // Inits
    this.makeSlides(this.carouselBreakpoint);
    this.activateFirst();
    this.nextPrev();
    this.indicatorClick();
    // Because of lazyloading, the min height as first recorded may
    // not be accurate and may need to be adjusted once images are loaded.
    // This will allow the carousel to grow, but it won't shrink.
    $(`#${this.element.id}`).on('slid.bs.carousel', this.addMinHeight);
    this.carouselBreakpoint.addListener(this.makeSlides);
  }

  /**
   * Given media query, determine number of items slide should show.
   *
   * @param  {bool} matches   Whether or not the query matches
   * @return {number}         Number of slides to show.
   */
  getItemsPerSlide(matches) {
    if (matches) {
      return 0 < this.numDesktopSlideItems
        ? this.numDesktopSlideItems : 1;
    }

    return 0 < this.numMobileSlideItems
      ? this.numMobileSlideItems : 1;
  }

  /**
   * Make slides # stored in desktopSlideItems on desktop
   */
  makeSlides(query) {
    const slideWrapperClass = 'carousel__slide-wrapper';
    const itemsPerSlide = this.getItemsPerSlide(query.matches);
    const slideItems = this.currentSlideItems;
    const slideContainer = this.slidesWrapper;
    const numBootstrapColumns = this.numDesktopRows
      ? itemsPerSlide / this.numDesktopRows
      : itemsPerSlide;
    const totalSlides = Math.ceil(slideItems.length / itemsPerSlide);

    /**
     * Create an array of all the items with the appropriate class indicating
     * the number of columns this item should span.
     * @param  {array} slideItems NodeList of HTMLElements inside carousel.
     * @param  {HTMLElement} item
     * @return {array}
     */
    const itemsWithColumnClasses = Array.from(slideItems).map((item) => {
      item.classList
        .add(`carousel__slide-content--${numBootstrapColumns}`);
      return item;
    });

    /**
     * Create a multidimentional array of items grouped by slide.
     * @param  {array} slideItems Items to be sorted into slides.
     * @return {array}
     */
    const groupsOfItemsForEachSlide = [...Array(totalSlides)]
      .reduce((acc, group, currentSlideIndex) => {
        // Establish containers
        const builtSlides = acc;
        const slide = [];

        // Loop through items in itemsWithColumnClasses, adding each item to
        // the slide until while our slide is not full.
        let itemIndex = 0;
        let keepSearching = true;
        while (keepSearching && slide.length < itemsPerSlide) {
          // Find the index of the next item in the array based on which
          // slide we are looking at and how many times we have looped
          // through this array.
          const nextIndex = (currentSlideIndex * itemsPerSlide) + itemIndex;

          // Get this item in the array.
          const nextItem = itemsWithColumnClasses[nextIndex];

          if (! nextItem) {
            // If we haven't found it, stop searching.
            keepSearching = false;
          } else {
            // Add this item to this slide's group.
            slide.push(nextItem);
            // Increase our counter through the items array.
            itemIndex += 1;
          }
        }

        // Add array to accumulator and return acumulator.
        builtSlides.push(slide);
        return builtSlides;
      },
      []);

    /**
     * Build the slide elements for inside the carousel.
     * @type {array} Array of HTMLElements prepared to hold slides.
     */
    const slideList = [...Array(totalSlides)]
      // Create slide
      // Append slide to slides wrapper
      // return reference to slide.
      .map(() => {
        const slide = document.createElement('div');
        slide.classList.add('item');
        slide.classList.add('carousel__slide');
        slideContainer.appendChild(slide);
        return slide;
      })
      // Append innerWrapper to slide.
      // The inner wrapper is necessary so there isn't a FOUC as the display
      // style changes on the slides.
      .map((slide) => {
        const slideInnerWrapper = document.createElement('div');
        slideInnerWrapper.classList.add(slideWrapperClass);
        slide.appendChild(slideInnerWrapper);
        // Return reference to slide to pipe array value through.
        return slide;
      });

    /**
     * Create a array full of the slides full of the items.
     * @param  {slideList} Array of HTMLElements prepared to hold slides.
     * @return {array}     Array of HTMLElements of populated slides.
     */
    const populatedSlides = slideList.map((slide, slideIndex) => {
      const wrapper = slide.querySelector(`.${slideWrapperClass}`);
      groupsOfItemsForEachSlide[slideIndex].forEach((item) => {
        wrapper.appendChild(item);
      });
      return slide;
    });

    /**
     * Fill slidesWrapper with the new slides as parsed.
     */
    const newSlideContainer = document.createElement('div');
    newSlideContainer.classList.add('carousel-inner');
    populatedSlides.forEach((slide) => newSlideContainer.appendChild(slide));
    slideContainer.parentNode.replaceChild(newSlideContainer, slideContainer);
    this.slidesWrapper = newSlideContainer;

    /**
     * Build an indicator for each slide.
     * @type {array}
     */
    const indicatorList = (1 < totalSlides)
      ? [...Array(totalSlides)]
        .map((cv, i) => {
          // Create indicator
          const newIndicator = document.createElement('li');
          newIndicator.setAttribute('data-target', `#${this.element.id}`);
          newIndicator.setAttribute('data-slide-to', `${i}`);
          // Return reference to indicator.
          return newIndicator;
        })
      : [];

    /**
     * Populate the indicators,
     */
    this.indicatorWrapper.innerHTML = '';
    indicatorList.forEach(
      (indicatorElement) => this.indicatorWrapper.appendChild(indicatorElement),
    );

    /**
     * Reset indicators.
     */
    this.indicatorReset();
    this.indicators = indicatorList;
    this.indicatorClick();

    /**
     * Update controls visibility based on number of slides visible.
     */
    if (1 >= totalSlides) {
      $(this.next).hide();
      $(this.prev).hide();
    } else {
      $(this.prev).show();
      $(this.next).show();
    }

    /**
     * Activate styling/loading behaviors.
     */
    this.slides = populatedSlides;
    this.activateFirst();
    if (1 < this.numDesktopRows && query.matches) {
      this.padRows();
    }

    // handle iframes
    this.loadIframes(query.matches);

    // for desktop tabs
    this.tab = document.querySelector(`[data-label="${this.tabId}"]`);
    // for mobile accordians
    this.panelHeading = document.querySelector(`[aria-controls="${this.tabId}-accordian"]`);

    if (null != this.tab) {
      this.tab.addEventListener('click', () => {
        this.loadIframes(query.matches);
      });
    }

    if (null != this.panelHeading) {
      this.panelHeading.addEventListener('click', () => {
        this.loadIframes(query.matches);
      });
    }

    $(`#${this.element.id}`).on('slid.bs.carousel', () => {
      this.loadIframes(query.matches);
    });
  }

  /**
   * Activate the first slide
   */
  activateFirst() {
    if (0 < this.slides.length) {
      this.slides[0].classList.add('active');
      if (0 < this.indicators.length) {
        this.indicators[0].classList.add('active');
      }
    }
  }

  /**
   * Add click and swipe handles for next and previous
   */
  nextPrev() {
    this.touchHandler.on('swipeleft', () => {
      this.$element.carousel('next');
    });

    this.touchHandler.on('swiperight', () => {
      this.$element.carousel('prev');
    });

    this.next.addEventListener('click', (event) => {
      event.preventDefault();
      this.$element.carousel('next');
    });

    this.prev.addEventListener('click', (event) => {
      event.preventDefault();
      this.$element.carousel('prev');
    });
  }

  /**
   * Add click to indicators
   */
  indicatorClick() {
    Array.from(this.indicators).forEach((indicator, idx) => {
      indicator.addEventListener('click', () => {
        this.$element.carousel(idx);
      });
    });
  }

  /**
   * Add click to indicators
   */
  indicatorReset() {
    Array.from(this.indicators).forEach((indicator, idx) => {
      indicator.removeEventListener('click', () => {
        this.$element.carousel(idx);
      });
    });
  }

  /**
   * Pad rows
   */
  padRows() {
    Array.from(this.slides).forEach((slide) => {
      const itemsPerRow = this.numDesktopSlideItems / this.numDesktopRows;
      const renderedSlideItems = slide.querySelectorAll(this.elements.slideItem);

      if (1 < parseInt(this.numDesktopRows, 10)) {
        for (let i = 0; i < itemsPerRow; i += 1) {
          if ('undefined' !== typeof renderedSlideItems[i]) {
            renderedSlideItems[i]
              .classList.add('carousel__slide-content--row-padding');
          }
        }
      }
    });
  }

  /**
   * Fix the height of the inside of the slideshow to the tallest slide.
   * @return {void}
   */
  addMinHeight() {
    // This should only run after the active slide is lazyloaded.
    // Cycle through all the slides and get their heights.
    const heights = Array.from(this.slides).map((slide) => $(slide).height());

    // Find the maximum height.
    const tallestSlideHeight = heights.reduce(
      (acc, val) => (acc > val ? acc : val),
      0,
    );

    // Apply that height to the parent node.
    this.slidesWrapper.style.minHeight = `${tallestSlideHeight}px`;
  }

  loadIframes(matches) {
    if (matches) {
      // if desktop tabs
      // eslint-disable-next-line max-len
      this.iframes = this.element.querySelectorAll('.tab-pane.active .carousel__slide.active .media-carousel-iframe');
    } else {
      // if mobile accordian
      // eslint-disable-next-line max-len
      this.iframes = this.element.querySelectorAll('.panel-collapse[aria-expanded="true"] .carousel__slide.active .media-carousel-iframe');
    }
    if (null != this.iframes) {
      Array.from(this.iframes).forEach((iframe) => {
        const iframeSrc = iframe.dataset.src;
        const embed = document.createElement('iframe');
        embed.src = iframeSrc;
        iframe.appendChild(embed);
        iframe.classList.remove('media-carousel-iframe');
      });
    }
  }
}
